import { IColumnValidator } from "@schemas/excelImportSchema";

export const emptyValidator: IColumnValidator = {
  validate: (value) => {
    return value != null && value !== "";
  },
  errorMessage: "Verdien skal ikke være tom",
};

export const increasingNumberValidator: IColumnValidator = {
  validate: (currentVal, dataSet, row, col) => {
    // current value should exist
    if (currentVal == null) {
      return false;
    }

    const currentValTrim = currentVal.toString().trim();

    // current value should not be empty
    if (currentValTrim === "") {
      return false;
    }

    const currentNum = Number(currentValTrim);

    // current value should be a number and larger than 0
    if (isNaN(currentNum) || currentNum < 0) {
      return false;
    }

    // Reject if first row and currentNum is an not an integer
    if (currentValTrim.indexOf(".") !== -1 && row === 0) {
      return false;
    }

    // Accept any number if first row
    if (row === 0) {
      return true;
    }

    const previousRow = dataSet[row - 1];
    const previousVal = previousRow[col];

    // previous value should exist
    if (previousVal == null) {
      return false;
    }

    const previousValTrim = previousVal.toString().trim();

    // current value and previous value should not be the same
    if (currentValTrim === previousValTrim) {
      return false;
    }

    const previousNum = Number(previousValTrim);

    // previous value should be a number and larger than 0
    if (isNaN(previousNum) || currentNum < 0) {
      return false;
    }

    const valParts = currentValTrim.split(".");
    const previousValParts = previousValTrim.split(".");

    const nums = [valParts[0], valParts[1], previousValParts[0], previousValParts[1]].map((part) => {
      return part == null ? 0 : Number(part);
    });

    // current integer value (category id) should be larger or equal to previous value
    return nums[0] >= nums[2];
  },
  errorMessage:
    "Verdien skal være et positivt tall i formatet 1 eller 1.1, og kategoriverdien må være større eller lik forrige verdi",
};

export const CHECKLIST_ZOD_EXCEL_VALIDATION = [increasingNumberValidator, emptyValidator];
